import { uniqueId } from '@utils/misc'
import HTTP_Client from '@services/support/http-client'
import { NEXT_PUBLIC_API_URL } from '@utils/constants'

class API_Client extends HTTP_Client {
  constructor() {
    super({
      baseURL: process.env.API_URL || (process.env.NEXT_PUBLIC_API_URL || (NEXT_PUBLIC_API_URL || '')),
    });
  }

  async request(method, path, body = {}, options = {}, urlParams = {}) {
    const response = await super.request(method, path, body, options, urlParams);

    if (typeof response.success === 'undefined') {
      this.error(this.lastRequest?.statusText);
      return { success: false };
    }

    response.response = {
      status: this.lastRequest?.status,
      text: this.lastRequest?.statusText
    };

    return response;
  }

  // TODO: Implement
  async upload(stream, name, path = '', versioned = false, options = {}) {
    if (versioned) {
      name = `${uniqueId()}-${name}`;
    }

    const body = new FormData();
    body.append('file', stream);
    body.append('path', path);
    body.append('name', name);

    return this.post('files/upload', body, options);
  }
}

export default function getClient() {
  let instance = null;

  if (! instance) {
    instance = new API_Client();
  }

  return instance;
}
